/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();

      // 👇 NUEVO: Captura el parámetro ?cliente= y guarda en localStorage
      const urlParams = new URLSearchParams(window.location.search);
      const cliente = urlParams.get('cliente');
      if (cliente) {
        localStorage.setItem('cliente_frutera', cliente);
      }

      // 👇 NUEVO: Inserta el valor en el campo de nota si existe
      const clienteGuardado = localStorage.getItem('cliente_frutera');
      if (clienteGuardado) {
        const notaCampo = this.querySelector('textarea[name="note"]');
        if (notaCampo && !notaCampo.value.includes(`Cliente: ${clienteGuardado}`)) {
          notaCampo.value = `Cliente: ${clienteGuardado}`;
          // También actualiza el carrito inmediatamente
          this.fetchRequestOpts.body = JSON.stringify({ note: notaCampo.value });
          fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
        }
      }
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      this.addEventListener('input', this.debouncedHandleNoteChange);
    }

    handleNoteChange(evt) {
      if (this.cartNoteToggle) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-note', CartNote);
}
